import { Icon, IconKey, IconKeys } from "../ui/icon";

/**
 * @internal For internal use only.
 *
 * Returns a mapping argTypes for Storybook
 * for icon.
 *
 * https://storybook.js.org/docs/api/arg-types#mapping
 */
export const getArgTypesMappingFromIcon = (propName?: string) => {
  return {
    [propName || "icon"]: {
      options: ["No icon", ...IconKeys],
      mapping: {
        "No icon": null,
        ...Object.fromEntries(
          // eslint-disable-next-line react/jsx-key -- lint-backlog: missing key; adding one changes reconciliation
          IconKeys.map(([key]) => [key, <Icon icon={key as IconKey} />]),
        ),
      },
    },
  };
};

/**
 * @internal For internal use only.
 *
 * Returns the value of a CSS variable.
 *
 * @param varName - The name of the CSS variable.
 * @returns The value of the CSS variable.
 */
export const getCSSVar = (varName: string) => {
  return getComputedStyle(document.documentElement)
    .getPropertyValue(varName)
    .trim();
};

/**
 * @internal For internal use only.
 *
 * Returns true if an object is empty.
 *
 * @param obj - The object to check.
 */
export const isObjectEmpty = (obj: object) => {
  return Object.keys(obj).length === 0;
};
